import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { APP_ROUTES_CONFIG } from '@contracts';
import { ModuleStore } from '@core';

export const moduleDefaultRedirectGuard: CanMatchFn = () => {
  const router = inject(Router);
  const moduleStore = inject(ModuleStore);
  const config = inject(APP_ROUTES_CONFIG);

  const currentModule = moduleStore.module();

  if (!currentModule) {
    return router.parseUrl('/login');
  }

  const targetPath = config.defaultRoutes[currentModule];

  if (!targetPath) {
    console.warn(`No default route defined for module: ${currentModule}`);
    return router.parseUrl('/');
  }

  return router.parseUrl(targetPath);
};
